






























import { defineComponent, computed, toRefs, PropType, onMounted } from '@vue/composition-api';
import { AdgroupFormData, CampaignFormData, PRODUCT_SPECIFIC_TYPE } from '@tt4b/ttam-enums';
import { trackEvent } from './../../../../utils/index';
import { useSpecTypeOpts } from '../hooks';
import { productTypeEditClick } from './../../../../track/edit-event';

const name = 'ttam-product-details-specific-type';
export default defineComponent({
  name,
  props: {
    productSpecificType: {
      type: Number,
      default: PRODUCT_SPECIFIC_TYPE.ALL,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      required: true,
      default: () => ({}),
    },
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { campaignData, adgroupData, productSpecificType, isEdit } = toRefs(props);
    const { options } = useSpecTypeOpts({
      campaignData,
      adgroupData,
    });
    const value = computed({
      get() {
        return productSpecificType.value || PRODUCT_SPECIFIC_TYPE.ALL;
      },
      set(val) {
        emit('products-detail-specific-type-change', val);
      },
    });
    const productTypeMap = {
      [PRODUCT_SPECIFIC_TYPE.ALL]: 'All products',
      [PRODUCT_SPECIFIC_TYPE.PRODUCT_SET]: 'Product set',
      [PRODUCT_SPECIFIC_TYPE.PRODUCTS]: 'Add products',
    };

    const onVisibleChange = isVisible => {
      if (isVisible) {
        trackEvent('module_ad_creative_nonshop_product_type_impression');
      }
    };

    const onOptionClick = (_value: number, isDefalut = false) => {
      trackEvent('module_ad_creative_nonshop_product_type_click', {
        product_type: productTypeMap[_value],
        pre_fill_or_not: isDefalut,
      });
      !isDefalut && isEdit.value && productTypeEditClick();
    };

    onMounted(() => {
      onOptionClick(value.value, true);
    });

    return {
      name,
      options,
      value,
      onVisibleChange,
      onOptionClick,
    };
  },
});
